import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { ProjectManifest } from "./types";
import type { ScannedProject } from "./workspace-scan";

export const activeProjectDirAtom = atom<string | null>(null);

export const activeProjectManifestAtom = atom<ProjectManifest | null>(null);

export const projectAudioFileAtom = atom<File | null>(null);

export const pendingAudioFileAtom = atom<File | null>(null);

export const createProjectPromptAtom = atom(false);

export const dismissedProjectPromptKeyAtom = atom<string | null>(null);

export const workspaceProjectsAtom = atom<ScannedProject[]>([]);

export const workspaceDirAtom = atomWithStorage<string | null>(
	"lastWorkspaceDir",
	null,
);

export const workspaceScanningAtom = atom(false);

export const pendingAudioPathAtom = atom<string | null>(null);

export const pendingLyricSourceAtom = atom<{
	path: string;
	lineIds: string[];
} | null>(null);

export const linkedBackupAvailableAtom = atom<boolean>(false);
